import type { Entities } from "../types"

export const entities: Entities = new Map([
  [
    "euler-dao",
    {
      name: "Euler DAO",
      logo: "entities/euler.svg",
      description:
        "The Euler DAO is the organisation responsible for the creation of the Euler lending/borrowing platform.",
      url: "https://euler.finance/",
      addresses: {
        "0xe55798d71193bAA789031415b668A992F2e566EE": "Euler DAO Multisig",
        "0xaB08F1986685A47eA2bDA6C02f74286517Fb615C":
          "Euler Vault Access Control Governor",
      },
      social: {
        twitter: "eulerfinance",
        youtube: "EulerFinance",
        discord: "https://discord.euler.finance/",
        telegram: "eulerfinance_official",
        github: "euler-xyz",
      },
    },
  ],
  [
    "gauntlet",
    {
      name: "Gauntlet",
      logo: "entities/gauntlet.svg",
      description:
        "Gauntlet's applied research and optimization teams model market risk, economic incentives, and drive sustainable growth for crypto's top protocols, chains, and onchain treasuries.",
      url: "https://www.gauntlet.xyz/",
      addresses: {
        "0xaB08F1986685A47eA2bDA6C02f74286517Fb615C":
          "Euler Vault Access Control Governor",
      },
      social: { twitter: "gauntlet_xyz" },
    },
  ],
  [
    "k3-capital",
    {
      name: "K3 Capital",
      logo: "entities/k3.svg",
      description:
        "K3 Capital provide leading institutional asset and risk management in decentralized finance.",
      url: "https://k3.capital/",
      addresses: {
        "0x060DB084bF41872861f175d83f3cb1B5566dfEA3": "K3 Fireblocks wallet",
      },
      social: { twitter: "k3_capital" },
    },
  ],
  [
    "alphagrowth",
    {
      name: "AlphaGrowth",
      logo: "entities/alphagrowth.svg",
      description:
        "Real stewardship, real growth. AlphaGrowth drives the blockchain industry forward by expanding token utility and accessibility through strategic partnerships and integrations.",
      url: "https://alphagrowth.io/",
      addresses: {
        "0x4f894Bfc9481110278C356adE1473eBe2127Fd3C": "Reservoir DAO Multisig",
      },
      social: { twitter: "alphagrowth1" },
    },
  ],
])
